module.exports = __webpack_public_path__ + "3fefdfe58fd47d8449a0b452af738a46.woff";